import Typography from 'typography';
import Wordpress2016 from 'typography-theme-wordpress-2016';

Wordpress2016.overrideThemeStyles = ({ rhythm }, options, styles) => {
  return {
    'a': {
      color: '#368ce2'
    },
    'a.gatsby-resp-image-link': {
      boxShadow: `none`,
    },
    'html, body': {
      color: '#1C2321',
      fontSize: '15px',
      fontFamily: ['Optima-Regular', 'PingFangTC-light', 'Georgia', 'serif'].join(','),
    },
    h1: {
      fontSize: '25px',
    },
    h2: { fontSize: '20px' },
    h3: { fontSize: '18px' },
    'h1, h2, h3, h4, h5, h6': {
      marginTop: rhythm(1.1),
      fontFamily: ['Optima-Regular', 'PingFangTC-light', 'Georgia', 'serif'].join(','),
      lineHeight: '1.3em'
    },
    li: {
      marginBottom: 'calc(1.75rem / 3)'
    },
    blockquote: { fontSize: '1rem' },
    'ul, ol': {
      margin: '0.3em 0 0 2em',
      padding: 0
    },
    p: {
      textAlign: 'justify',
    },
  };
};

delete Wordpress2016.googleFonts;

const typography = new Typography(Wordpress2016);

// Hot reload typography in development.
if (process.env.NODE_ENV !== `production`) {
  typography.injectStyles();
}

export default typography;
export const rhythm = typography.rhythm;
export const scale = typography.scale;
